/* ==========================================================================
   whero-flavor-grid.js — sort the auto-source pool by closest-shop
   relevance.
   --------------------------------------------------------------------------
   Each .whero-flavor-grid__list[data-flavor-grid-mode="auto"] is rendered
   server-side with up to 8 cards in DOM order. CSS shows the first 4
   (nth-child(n+5) → display:none). When whero:status-updated fires:

     1. Resolve the closest shop's slug via the grid's shop-id-to-slug map.
     2. Score each card by shop_availability[closestSlug]:
          0 = explicitly true            (most relevant)
          1 = missing key (treat as maybe-available)
          2 = explicitly false           (least relevant)
     3. Stable sort cards ascending by score. Reorder DOM.
     4. CSS keeps showing the first 4 children — now they're the 4
        most-relevant to the user.

   Manual-mode grids ([data-flavor-grid-mode="manual"]) are skipped — the
   merchant hand-picked those, respect their order.
   ========================================================================== */
(function () {
  'use strict';

  function safeParse(s) {
    if (!s) return null;
    try { return JSON.parse(s); } catch (_) { return null; }
  }

  function scoreFor(availability, slug) {
    if (!availability || !slug) return 1;
    var v = availability[slug];
    if (v === true) return 0;
    if (v === false || v === null) return 2; // 86'd or out of rotation here
    return 1; // missing key (not bridge-managed)
  }

  function sortGrid(grid, closestSlug) {
    var idMap = safeParse(grid.getAttribute('data-shop-id-to-slug'));
    // We only need closestSlug here; idMap was used by the caller.
    if (!closestSlug) return;

    var items = Array.prototype.slice.call(grid.children);
    if (items.length === 0) return;

    // Compute scores.
    var scored = items.map(function (el, i) {
      var availability = safeParse(el.getAttribute('data-shop-availability')) || {};
      return {
        el: el,
        score: scoreFor(availability, closestSlug),
        originalIndex: i, // for stable-sort tie-breaking
      };
    });

    // Stable sort ascending by score, falling back to original index.
    scored.sort(function (a, b) {
      if (a.score !== b.score) return a.score - b.score;
      return a.originalIndex - b.originalIndex;
    });

    // Reorder DOM only if the order actually changed (avoids needless
    // reflow + lets the browser keep current focus + scroll positions).
    var changed = false;
    for (var i = 0; i < scored.length; i++) {
      if (scored[i].originalIndex !== i) { changed = true; break; }
    }
    if (!changed) return;

    var frag = document.createDocumentFragment();
    for (var j = 0; j < scored.length; j++) frag.appendChild(scored[j].el);
    grid.appendChild(frag);
  }

  function handleStatusUpdated(e) {
    var detail = (e && e.detail) || {};
    var closestId = detail.closestShop && detail.closestShop.id;
    if (!closestId) return;

    var grids = document.querySelectorAll('.whero-flavor-grid__list[data-flavor-grid-mode="auto"]');
    for (var i = 0; i < grids.length; i++) {
      var grid = grids[i];
      var idMap = safeParse(grid.getAttribute('data-shop-id-to-slug')) || {};
      var closestSlug = idMap[closestId];
      if (closestSlug) sortGrid(grid, closestSlug);
    }
  }

  document.addEventListener('whero:status-updated', handleStatusUpdated);
})();
